export default __webpack_public_path__ + "static/media/CH0164.abe2261d.png";